export default {
  DEV: 1,
  STAGE: 2,
  LIVE: 3
};



// WEBPACK FOOTER //
// ./node_modules/@aofl/server-environment/src/EnvironmentTypeEnumerate/index.js